export const GET_NEWSPAGE_BY_ID_METHOD = (id: any, preview: boolean) => `
  query {
    newspage(id: "${id}", preview: ${preview}) {
    sys {
        id
      }
      linkedFrom {
        pageCollection(limit: 1) {
          items {
            sys {
              id
            }
          }
        }
      }
      newsType
      heading
      publishDate
      hidePublishDate
      releaseDate
      preamble
      mainBody{
        json
        links {
          entries {
            hyperlink {
              ... on Page {
                sys {id}
                slug
                content {
                  __typename
                }
              }
              ... on FileBlock {
                sys {id}
                imageVaultFile
                metaData
                __typename
              }
            }
            block {
              __typename
              ... on ImageBlock {
                sys {id}
                ivImage
                enableZoom
                imageDescription
                link {
                  globalLinkItem
                  reference {
                    ...on Page {
                      slug
                    }
                    ...on FileBlock
                    {
                      imageVaultFile
                    }
                  }
                  url
                  newTab
                }
              }
              ... on TableBlock {
                sys {id}
                heading
                table
              }
                ... on TextList {
                      sys {id}
                      listStyle
                      texts
               }
            }
          }
        }
      }
      ivMainImage
      topImageText
      mainAreaCollection {
        items {
          __typename
          ... on RichTextBlock {
            sys {
              id
            }
          }
          ... on AccordionBlock {
            sys {
              id
            }
          }
          ... on FileBlock {
            sys {
              id
            }
          }
          ... on InformationBlock {
            sys {
              id
            }
          }
          ... on InsurancePickerBlock {
            sys {
              id
            }
          }
          ... on TeaserBlock {
            sys {
              id
            }
          }
          ... on Link {
            sys {
              id
            }
          }
          ... on Sectionblock {
            sys {
              id
            }
          }
          ... on Videoblock {
            sys {
              id
            }
          }
          ... on TableBlock {
            sys {
              id
            }
          }
          ... on Page {
            sys {
              id
            }
          }
          ... on PersonalizationBlock {
            sys {
              id
            }
          }
          ... on ContactBlock {
            sys {
              id
            }
          }
          ... on QuoteBlock {
            sys {
              id
            }
          }
          ... on TimelineBlock {
            sys {
              id
            }
          }
          ... on ListBlock {
            sys {
              id
            }
          }
          ... on FaqListBlock {
            sys {
              id
            }
          }
          ...on ImageBlock {
            sys {
              id
            }
          }
          ...on FileListBlock {sys{id}}
          ... on BannerBlock {
            sys {
              id
            }
          }
          ... on ContactUsBlock {
            sys {
              id
            }
          }
          ... on LinkTeaserBlock {sys {id}}
        }
      }
      relatedContentHeading
      relatedContentSmallImages
      relatedContentCollection {
        items {
          __typename
          ...on TeaserBlock{sys{id}}
          ...on Page{sys{id}}
        }
      }
    }
  }
`;
